import { ServerSideRowModelModule } from "ag-grid-enterprise";
import { ModuleRegistry } from '@ag-grid-community/core';
import { observer } from "mobx-react";
import useStore from "../../../../store";
import { ServerGridConfig } from "../../../../config/GridConfig";
import { AgGridReact } from 'ag-grid-react';
import Message from '../../../../config/Message';
import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

const ListComponent = observer(() => {
	ModuleRegistry.registerModules([ServerSideRowModelModule]);
	dayjs.extend(utc);
	dayjs.extend(timezone);

	const { ENQUIRY } = useStore();

	const colDefs = [
		{
			headerName: 'Enquiry Date',
			field: 'createdOn',
			minWidth: 175,
			sort: 'desc',
			valueFormatter: ({ value }) => {
				return value
				? dayjs.utc(value).tz('Asia/Kolkata').format('DD/MM/YYYY hh:mm A'): '';
			},
		},
		{
			headerName: 'Enquiry Type',
			field: 'enquiryType',
			minWidth: 150,
		},
		{
			headerName: 'Name',
			field: 'name',
			minWidth: 175,
		},
		{
			headerName: 'Mobile No',
			field: 'mobileNumber',
			minWidth: 120,
		},
		{
			headerName: 'Email',
			field: 'email',
			minWidth: 50,
		},
		{
			headerName: 'City Name',
			field: 'city',
			minWidth: 100,
		},
		{
			headerName: 'Property Name',
			field: 'propertyName',
			minWidth: 100,
		},
		{
			headerName: 'Description',
			field: 'description',
			minWidth: 170,
		},


	];
	return (
		<div
			className="ag-theme-quartz"
			style={{ height: 'calc(100vh - 160px)' }}
		>
			<AgGridReact
				onGridReady={ENQUIRY.setupGrid}
				headerHeight={35}
				columnDefs={colDefs}
				defaultColDef={ServerGridConfig.defaultColDef}
				columnTypes={ServerGridConfig.columnTypes}
				overlayNoRowsTemplate={Message().noRecord}
				gridOptions={ServerGridConfig.options}
			/>
		</div>
	);
})

export default ListComponent;